import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { fetchPrivateFile, fileErrorMessage } from '@/lib/privateFiles';

export const PrivateFileContent = ({ source, image = false, title = 'Document', testId = 'private-file', className = '', style, onLoad }) => {
    const [state, setState] = useState({ source: null, url: null, error: null });
    useEffect(() => {
        if (!source) return;
        const abort = new AbortController();
        let url;
        setState({ source, url: null, error: null });
        fetchPrivateFile(source, abort.signal).then(({ data }) => {
            if (abort.signal.aborted) return;
            url = URL.createObjectURL(data); setState({ source, url, error: null });
        }).catch(async (error) => {
            const message = await fileErrorMessage(error);
            if (!abort.signal.aborted) setState({ source, url: null, error: message });
        });
        return () => { abort.abort(); if (url) URL.revokeObjectURL(url); };
    }, [source]);
    if (state.source !== source || (!state.url && !state.error)) return (
        <div role="status" data-testid={`${testId}-loading`} className="flex h-full min-h-24 items-center justify-center gap-2 text-sm">
            <Loader2 className="h-5 w-5 animate-spin" /> Chargement du document…
        </div>
    );
    if (state.error) return <div role="alert" data-testid={`${testId}-error`} className="p-6 text-center text-sm text-red-600">{state.error}</div>;
    return image ? <img src={state.url} alt={title} className={className} style={style} onLoad={onLoad} data-testid={testId} /> :
        <iframe src={state.url} title={title} className={className} style={style} onLoad={onLoad} data-testid={testId} />;
};